import React from 'react';
import PropTypes from 'prop-types';

import ResellerWarningText from 'apps/age_gate/components/ResellerWarningText';
import WarrantySupportText from 'apps/age_gate/components/WarrantySupportText';
import AVRequiredText from 'apps/age_gate/components/AVRequiredText';
import LanguageSelector from 'apps/age_gate/components/LanguageSelector';
import { switchToLocale } from 'common/url_locale_helper';

export default class FooterContainer extends React.Component {
  static propTypes = {
    configurations: PropTypes.object.isRequired,
  };

  resellerWarningComponent = () => {
    const {
      configurations: { reseller_warning },
    } = this.props;

    return reseller_warning && <ResellerWarningText />;
  };

  warrantySupportComponent = () => {
    const {
      configurations: { warranty_support },
    } = this.props;

    return warranty_support && <WarrantySupportText />;
  };

  avRequiredComponent = () => {
    const {
      configurations: { av_required },
    } = this.props;

    return av_required && <AVRequiredText />;
  };

  onLanguageSelection = e => {
    return switchToLocale(e.target.value);
  };

  languageSelectorComponent = () => {
    const {
      configurations: { language_selector },
    } = this.props;
    if (!language_selector) return null;

    const { languages } = language_selector;
    // To render a language, need to have atleast two available locales
    if (languages && languages.length > 1) {
      return (
        <LanguageSelector
          languages={languages}
          onLanguageSelection={this.onLanguageSelection}
        />
      );
    }

    return null;
  };

  render() {
    return (
      <div className="Modal__footer age-gate__footer">
        {this.resellerWarningComponent()}
        {this.warrantySupportComponent()}
        {this.avRequiredComponent()}
        {this.languageSelectorComponent()}
      </div>
    );
  }
}
